function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { USAGE_CAPS_URL } from '../../../../servicesAndUsage/usageCaps/usage.caps.constants';
var UsageChargesAndCapsController = /*#__PURE__*/function () {
  function UsageChargesAndCapsController($ngRedux) {
    var _this = this;
    _classCallCheck(this, UsageChargesAndCapsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      moreMenuItems: [{
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS),
        action: function action() {
          return _this.actions.stateGo(USAGE_CAPS_URL, {
            serviceId: _this.serviceValue
          });
        }
      }]
    });
  }
  return _createClass(UsageChargesAndCapsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        stateGo: stateGo
      };
      var mapStateToProps = function mapStateToProps() {
        return {};
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(_ref) {
      var itemProps = _ref.item;
      itemProps.action(itemProps);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    serviceValue: '<',
    totalCharge: '<',
    usageCaps: '<'
  },
  controller: UsageChargesAndCapsController,
  template: require('./usage.charges.and.caps.template.html')
};